import { render, staticRenderFns } from "./MyDepositTab.vue?vue&type=template&id=7e5562ea"
import script from "./MyDepositTab.vue?vue&type=script&lang=js"
export * from "./MyDepositTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports